function a(t) {
  var o, n, e = "";
  if (typeof t == "string" || typeof t == "number")
    e += t;
  else if (typeof t == "object")
    if (Array.isArray(t))
      for (o = 0; o < t.length; o++)
        t[o] && (n = a(t[o])) && (e && (e += " "), e += n);
    else
      for (o in t)
        t[o] && (e && (e += " "), e += o);
  return e;
}
function q() {
  for (var t, o, n = 0, e = ""; n < arguments.length; )
    (t = arguments[n++]) && (o = a(t)) && (e && (e += " "), e += o);
  return e;
}
const s = "rich-text", x = "hero__text", l = "mobile", _ = "tablet", r = "desktop", d = "button__text-primary", i = "button__title", p = "button__title__map", g = "button__heroTitle", b = "heading__page", c = "heading__section", u = "heading__menu", T = "texts__component_title", h = "texts__component_title--bold", m = "texts__lead_text", y = "page__lead_text", B = "texts__lead_text--bold", f = "texts__paragraph_subtitle", C = "texts__paragraph_subtitle--bold", L = "texts__body_text", P = "texts__body_text--bold", k = "texts__link", H = "texts__caption", M = "texts__caption--bold", A = "page__heading", w = {
  richText: s,
  heroText: x,
  mobile: l,
  tablet: _,
  desktop: r,
  buttonTextPrimary: d,
  buttonTitle: i,
  buttonTitleMap: p,
  buttonHeroTitle: g,
  headingPage: b,
  headingSection: c,
  headingMenu: u,
  textsComponentTitle: T,
  textsComponentTitleBold: h,
  textsLeadText: m,
  pageLeadText: y,
  textsLeadTextBold: B,
  textsParagraphSubtitle: f,
  textsParagraphSubtitleBold: C,
  textsBodyText: L,
  textsBodyTextBold: P,
  textsLink: k,
  textsCaption: H,
  textsCaptionBold: M,
  pageHeading: A
};
var j = /* @__PURE__ */ ((t) => (t[t.xs = 0] = "xs", t[t.sm = 600] = "sm", t[t.md = 900] = "md", t[t.lg = 1024] = "lg", t[t.xl = 1440] = "xl", t))(j || {});
export {
  j as D,
  q as c,
  w as t
};
//# sourceMappingURL=app-a75c1d35.mjs.map
